import { PlusOutlined } from '@ant-design/icons';
import { useGetSensitiveConfigsMeta } from '@src/emp-3.0/api/queryHooks';
import { Button, Select } from 'antd';
import React, { useMemo, useState } from 'react';

const CCSConfigurationHeader = ({ addNewConfig, setFilter, openNewConfig }) => {
  const [type, setType] = useState<string>('');
  const [value, setValue] = useState<string>('');

  const { data, isLoading: isLoadingMeta } = useGetSensitiveConfigsMeta();
  const options = useMemo(() => {
    if (!data || !type) return [];
    setValue('');
    return data?.[type]?.map((type) => {
      return {
        label: type,
        value: type,
      };
    });
  }, [data, type]);

  const handleTypeChange = (value) => {
    setType(value);
    setValue('');
  };

  const handleValueChange = (value) => {
    setValue(value);
  };

  const handleFindConfig = () => {
    if (type && value) setFilter(`${type}=${value}`);
    else setFilter('');
  };

  return (
    <div>
      <div style={{ display: 'flex', padding: '5px 16px', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', gap: '5px' }}>
          Filter By:
          <Select
            showSearch
            defaultValue="All"
            style={{ width: 120 }}
            onChange={handleTypeChange}
            options={[
              { value: '', label: 'All' },
              { value: 'config_id', label: 'Config Id' },
              { value: 'platform', label: 'Platform' },
              { value: 'sensor_version', label: 'Sensor Version' },
            ]}
          />
          <Select
            showSearch
            style={{ width: 120 }}
            loading={isLoadingMeta}
            disabled={!type}
            value={value}
            onChange={handleValueChange}
            options={options}
          />
          <Button onClick={handleFindConfig}>Find</Button>
        </div>
        <Button type="link" icon={<PlusOutlined />} onClick={addNewConfig} disabled={openNewConfig}>
          New CCS Config
        </Button>
      </div>
    </div>
  );
};

export default CCSConfigurationHeader;
